"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JobStateEnum;
(function (JobStateEnum) {
    JobStateEnum["SUCCESS"] = "SUCCESS";
    JobStateEnum["FAILURE"] = "FAILURE";
    JobStateEnum["QUEUED"] = "QUEUED";
    JobStateEnum["RUNNING"] = "RUNNING";
})(JobStateEnum = exports.JobStateEnum || (exports.JobStateEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiam9iLXN0YXRlLmVudW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZW51bXMvam9iLXN0YXRlLmVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxJQUFZLFlBS1g7QUFMRCxXQUFZLFlBQVk7SUFDdEIsbUNBQW1CLENBQUE7SUFDbkIsbUNBQW1CLENBQUE7SUFDbkIsaUNBQWlCLENBQUE7SUFDakIsbUNBQW1CLENBQUE7QUFDckIsQ0FBQyxFQUxXLFlBQVksR0FBWixvQkFBWSxLQUFaLG9CQUFZLFFBS3ZCIn0=